exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".projects-trans-transition[_v-ceded444]{transition:all .5s ease}.projects-trans-enter[_v-ceded444],.projects-trans-leave[_v-ceded444]{z-index:-1;opacity:0;position:absolute}.projects-trans-move[_v-ceded444]{transition:-webkit-transform .5s cubic-bezier(.55,0,.1,1);transition:transform .5s cubic-bezier(.55,0,.1,1);transition:transform .5s cubic-bezier(.55,0,.1,1),-webkit-transform .5s cubic-bezier(.55,0,.1,1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-ceded444&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Projects.vue
// module id = 59
// module chunks = 0